import { configureStore } from '@reduxjs/toolkit';
import authReducer from "../features/auth/authSlice";
import targetReducer from "../features/display/displaySlice";
import { middleware } from "./services/middleware";
import { backendApi } from "./services/backendApi";

const store = configureStore({
  reducer: {
    auth: authReducer,
    display: targetReducer,
    [middleware.reducerPath]: middleware.reducer,
    [backendApi.reducerPath]: backendApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      middleware.middleware,
      backendApi.middleware
    ),
});

export default store;
